<template>
  <div>
    <div class="payment-link-order">
      <el-form ref="form" :model="form" label-width="250px" label-position="left">
        <template v-if="tableData && tableData.length>0">
          <div class="title">{{ $t('payment_links.product_info') }}</div>
          <div class="tableContainer">
            <el-table
              :data="tableData"
              stripe
              fit
              highlight-current-row
              style="width: 100%"
              max-height="500px"
            >
              <el-table-column :label="$t('payment_links.product_name')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('payment_links.price')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.price | toDivideWithDot }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('payment_links.quantity')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.quantity }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('payment_links.amount')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.total_amount | toDivideWithDot }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
        <div class="title">{{ $t('payment_links.customer_info') }}</div>
        <el-form-item :label="$t('payment_links.customer_name')">
          <span class="content-text">{{ form.customer_name | strAesDecryptAndAsterisk }}</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.customer_email')">
          <span class="content-text">{{ form.email | strAesDecryptAndAsterisk }}</span>
        </el-form-item>
        <el-form-item :label="$t('payment_links.customer_mobile')">
          <span class="content-text">{{ form.mobile | strAesDecryptAndAsterisk }}</span>
        </el-form-item>

        <template v-if="fieldInfoList.length>0">
          <div class="title">{{ $t('payment_links.other_info') }}</div>
          <el-form-item v-for="(item, index) in fieldInfoList" :key="index" :label="item.name">
            <span class="content-text">{{ item.value }}</span>
          </el-form-item>
        </template>
        <el-form-item label="Branch Code" v-if="branch_code">
          <span class="content-text">{{ branch_code }}</span>
        </el-form-item>
        <el-form-item label="Branch Name" v-if="branch_name">
          <span class="content-text">{{ branch_name }}</span>
        </el-form-item>
      </el-form>

    </div>
  </div>
</template>

<script>

export default {
  name: 'Order_Detail',
  props: {
    orderData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      fieldInfoList: [],
      tableData: null,
      form: {},
      branch_code:'',
      branch_name:''
    }
  },
  watch: {
    orderData(newVal) {
      this.form = newVal.payment_checkout_order
      this.tableData = newVal.payment_link_checkout.product_info_list
      this.fieldInfoList = newVal.payment_link_checkout.field_info_list
      this.branch_code = ''
      this.branch_name = ''
      if (Array.isArray(newVal.payment_link_checkout.payment_link_trans_info_resp_list)) {
        newVal.payment_link_checkout.payment_link_trans_info_resp_list.forEach(item => {
          if (item.filed_key === 'branchCode') {
            this.branch_code = item.filed_value
          }
          if (item.filed_key === 'branchName') {
            this.branch_name = item.filed_value
          }
        })
      }
    }
  }
}
</script>

<style lang = "scss" scoped>
.payment-link-order{
  .title{
    font-size: 16px;
    color: #000;
    font-weight: 600;
    padding: 24px 24px 12px;
    border-bottom: 1px solid #D3D7DF;
    margin-bottom: 12px;
  }
  .tableContainer{
    margin: 0 24px 12px;
  }
  ::v-deep .el-form-item{
    margin-bottom: 0;
    .el-form-item__label{
      padding-left: 24px;
      color: #1D3A71;
      font-family: Inter;
      font-weight: 600;
    }
    .content-text{
      color: #1D3A71;
      font-family: Inter;
      font-size: 12px;
      font-weight: 500;
    }
  }
}
</style>
